import { DEFAULT_CURRENCY_CODE, getCountryCurrencyCode } from '@/utils/money';
import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useWrappedQuery } from './use-wrapped-query';

export const SUPPLIER_ADDRESS_QUERY = gql`
  query GetSupplierAddressCountryCode($supplierUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      address {
        country_code
        uuid
      }
      uuid
    }
  }
`;

export const useSupplierCurrencyCode = (supplierUUID: string | undefined) => {
  const { data } = useWrappedQuery(SUPPLIER_ADDRESS_QUERY, {
    skip: !supplierUUID,
    variables: {
      supplierUUID,
    },
  });

  const currencyCode = useMemo(() => {
    const countryCode = data?.businesses_by_pk?.address?.country_code;
    return countryCode
      ? getCountryCurrencyCode(countryCode)
      : DEFAULT_CURRENCY_CODE;
  }, [data?.businesses_by_pk?.address?.country_code]);

  return {
    currencyCode,
  };
};
